// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headerTitle[data-v-3a201278]{margin-bottom:25px}.headerTitle .searchBox[data-v-3a201278]{display:flex;margin:25px 0}.headerTitle .searchBox .left[data-v-3a201278]{width:80%}.headerTitle .searchBox .left .wid[data-v-3a201278]{width:20%}.headerTitle .searchBox .right[data-v-3a201278]{width:20%;text-align:right}", ""]);
// Exports
module.exports = exports;
